<template>
    <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Verzendkosten inkoopprijs (excl. btw)</h3>
        </div>
        <div class="block-content p-0">
          <table class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th>Land</th>
                <th>Verkoopkanaal</th>
                <th>Brievenbuspakket</th>
                <th>Kleinpakket</th>
                <th>Pakketpost</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="shipping_cost in shipping_costs" :key="shipping_cost.id">
                <td>
                  <a>{{shipping_cost.country}}</a>
                </td>
                <td>
                  <a>{{shipping_cost.sales_channel}}</a>
                </td>
                <td>
                  <div class="row">
                    <input v-model="letterboxPackages[shipping_cost.id]" type="number" ref="input" class="form-control" style="width: 100px;">
                    <button type="submit" class="btn btn-success btn-noborder"  @click="updateShippingCostField(shipping_cost.id, 'letterbox_package', shipping_cost.sales_channel)">
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                </td>
                <td>
                  <div class="row">
                    <input v-model="smallPackages[shipping_cost.id]" type="number" ref="input" class="form-control" style="width: 100px;">
                    <button type="submit" class="btn btn-success btn-noborder"  @click="updateShippingCostField(shipping_cost.id, 'small_package', shipping_cost.sales_channel)">
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                </td>
                <td>
                  <div class="row">
                    <input v-model="parcelPosts[shipping_cost.id]" type="number" ref="input" class="form-control" style="width: 100px;">
                    <button type="submit" class="btn btn-success btn-noborder"  @click="updateShippingCostField(shipping_cost.id, 'parcel_post', shipping_cost.sales_channel)">
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
</template>
<script>
import http from '../utils/http'

export default {
  data () {
    return {
      shipping_costs: null,

      letterboxPackages: [],
      parcelPosts: [],
      smallPackages: []
    }
  },
  methods: {
    loadData () {
      this.$api.getShippingCosts()
        .then((result) => {
          this.shipping_costs = result.data
          this.fillArrays()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning')
        })
    },
    updateShippingCostField (id, field, salesChannel) {
      var value = null
      if (field === 'letterbox_package') {
        value = this.letterboxPackages[id]
      } else if (field === 'small_package') {
        value = this.smallPackages[id]
      } else {
        value = this.parcelPosts[id]
      }

      const data = {
        [field]: value,
        'sales_channel': salesChannel
      }

      http.patch(`/shipping-costs/${id}`, data)
        .then((result) => {
          this.$swal('Hoera 😊', `De verzendkosten zijn succesvol bijgewerkt.`, 'success')
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan met het bijwerken van de verzendkosten. Probeer het opnieuw.', 'warning')
        })
    },
    fillArrays () {
      this.shipping_costs.forEach(element => {
        this.letterboxPackages[element.id] = element.letterbox_package
        this.parcelPosts[element.id] = element.parcel_post
        this.smallPackages[element.id] = element.small_package
      })
    }
  },
  created () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// ShippingCostTab.vue?4cb733ee